module.exports = __webpack_public_path__ + "static/media/social6.1ac1faa2.png";